import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import i18n from 'i18next';
import {
	getProject,
	getToken,
	getTempUserId,
	getURLSourceValue,
	mobileRedirect,
	postMessageWeb,
	removeToken,
	getSession,
} from '../common/tools';
import { toast } from 'react-toastify';
import { UNAUTHORIZED } from '../common/errorCodes';
import { WEB_SOURCE } from '../common/constants';
import { _jwt, _locale, _project, _session, _source } from '../components/providers/main.provider';

const API: AxiosInstance = axios.create({ baseURL: `${window.location.origin}/api` });

API.interceptors.request.use(async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
		const params: URLSearchParams = new URLSearchParams(window.location.search);

		const jwt: string | null = params.get('jwt') || _jwt;
		const session: string | null = params.get('session') || _session;
		const source: string | null = params.get('source') || _source;
		const locale: string | null = params.get('locale') || _locale;
		const project: string | null = params.get('project') || _project;

		config.headers['frontend-language'] = i18n.language;
		config.headers['Accept'] = 'application/json';
		config.headers['session'] = session || getSession();
		config.headers['source'] = source || WEB_SOURCE;
		config.headers['locale'] = locale || i18n.language;
		config.headers['project'] = project || getProject();

		if (jwt) {
			config.headers['Authorization'] = `Bearer ${jwt}`;
		} else {
			const accessToken: string = getToken();

			if (accessToken) {
				config.headers['Authorization'] = `Bearer ${accessToken}`;
			}
		}

		const tempUserId: string = getTempUserId();

		if (tempUserId) {
			config.headers['Temp-User-Id'] = tempUserId;
		}

		return config;
	},
	(error): void => {
		void Promise.reject(error);
	},
)

API.interceptors.response.use((response: AxiosResponse) => {
	return response;
}, (error): any => {
	if (error?.response?.status === 401) {
		const source: string = getURLSourceValue();
		const errData = error?.response?.data || error;

		if (source === 'web') {
			postMessageWeb({ errData }, 'unauthorized', true, UNAUTHORIZED);
		} else if (source === 'mobile') {
			mobileRedirect({ errData }, 'unauthorized', true, UNAUTHORIZED);
		} else {
			removeToken();
			toast.error('UNAUTHORIZED! INVALID_TOKEN!');
			window.location.href = '/session/login';
		}
	}

	return Promise.reject(error);
});

export { API };
